import { Button, Card, Typography } from '../../components/primitives';
import { useProjectsContext } from '../../context/projects.context';
import { testId } from '../../utils';
import { useTranslation } from '@rpi/i18n';

export const NoFilteredProjectsCard = () => {
  const { handleClearFilters } = useProjectsContext();
  const { t } = useTranslation(undefined, {
    keyPrefix: 'route.project-filter',
  });
  return (
    <Card {...testId('no-filtered-projects')}>
      <div className="p-8 space-y-6">
        <div className="space-y-4">
          <Typography as="h3" variant="sub-title">
            {t('no_filtered_projects')}
          </Typography>
        </div>
        <div>
          <Button
            {...testId('clear-filters-button')}
            size="sm"
            onClick={handleClearFilters}
          >
            {t('clear_filters')}
          </Button>
        </div>
      </div>
    </Card>
  );
};
